import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-alarm",
  "use": "app-icon-alarm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-alarm\"><path d=\"M9.959 13c-.32 1.163-1.176 2-2.187 2s-1.867-.837-2.188-2H9.96zm4.436-1.74c.106.074.146.2.146.317 0 .053-.006.1-.026.153a.422.422 0 01-.397.27H1.423A.421.421 0 011 11.577c0-.117.04-.243.146-.316C5.656 8.193 2.27 1 7.772 1c5.501 0 2.115 7.193 6.623 10.26z\" fill=\"#F77\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol